import type { PatentInfo } from '../types';
import type { CurrentStep } from '../enums';

/**
 * 专利服务接口
 * 负责管理专利数据的获取和状态管理
 */
export interface PatentsService {
    /**
     * 根据搜索轮次和步骤加载专利数据
     * @param roundIndex - 搜索轮次索引
     * @param step - 当前执行步骤
     */
    loadPatentsByRoundAndStep(roundIndex: number, step: CurrentStep): Promise<void>;

    /**
     * 清空专利数据
     */
    clearPatents(): void;

    /**
     * 获取当前专利数据
     * @returns 当前的专利数据数组
     */
    getCurrentPatents(): PatentInfo[];

    /**
     * 获取专利数据数量
     * @returns 当前专利数据的数量
     */
    getPatentsCount(): number;
}

export const PatentsService = Symbol('PatentsService');
